export const pfPt = {
  port_name: "port_name",
  exter_port: "exter_port",
  internal_port: "internal_port",
  lan_ip: "lan_ip",
  attach_device: "attach_device",
};

export default pfPt;
